import { Resolve, ActivatedRouteSnapshot } from "@angular/router";
import { Injectable } from "@angular/core";
import { LatestUpdate } from "../models/latestupdate";
import { LatestUpdateService } from "../services/latestupdate.service";
import { Observable } from "rxjs";

@Injectable()
export class LatestUpdatesResolver implements Resolve<LatestUpdate[]> {

    constructor(private latestUpdateService: LatestUpdateService) {
    }

    resolve(route: ActivatedRouteSnapshot): Observable<LatestUpdate[]> {
        // todo: route.params["id"] - explicitly passsing it as 4 at the moment.
        return this.latestUpdateService.getUpdates();
    }
}
